module.exports = __webpack_public_path__ + "static/media/darkBG01.b0bb8ec4.png";